/* AI 시공사례 — 문서 모델 (서버 CONTENT_JSON v2 와 같은 모양)
   페이지 720×960 위에 요소(글·사진·도형)를 절대 위치로 놓는다. 공개 페이지(viewer-template.html)도 같은 데이터를 그린다. */

export const PAGE_W = 720;
export const PAGE_H = 960;

export type ElType = 'text' | 'image' | 'shape';
export type Role = 'main' | 'sub' | 'heading' | 'body' | 'kicker';
export type Align = 'left' | 'center' | 'right';

/** AI가 채울 글 표시 — 생성이 끝나면 지운다 */
export interface GenSpec {
  kind: 'overview' | 'roomBody' | 'detail';
  room?: string;
  focus?: string | null;
}

export interface El {
  id: string;
  type: ElType;
  x: number;
  y: number;
  w: number;
  h: number;
  z: number;
  rot?: number;
  opacity?: number;
  flipX?: boolean;
  flipY?: boolean;
  radius?: number;
  role?: Role;
  // 글
  text?: string;
  fontSize?: number;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  align?: Align;
  color?: string;
  font?: string;
  ls?: string;
  lh?: string | number;
  bg?: string;
  pad?: string;
  vcenter?: boolean;
  // 사진 — 인디포토 사진(photoId·externalId) 또는 AI 편집 사진(aiImgId). src 는 화면·공개 페이지가 쓰는 주소
  src?: string;
  photoId?: number;
  externalId?: string;
  /** 사진의 현장(인디포토) — 시공사례·현장 연결(현장으로 찾기)에 쓴다 */
  siteId?: number;
  aiImgId?: number;
  /** AI로 고치기 전 맨 처음 사진 — "원복" 기준 */
  origSrc?: string;
  origPhotoId?: number;
  origExternalId?: string;
  clip?: string;
  // 도형
  kind?: string;
  stroke?: string;
  sw?: number;
  dash?: string;
  arrow?: string;
  // 생성 중에만
  gen?: GenSpec;
  sample?: string;
}

export interface Page {
  id: string;
  kind?: string;
  bg: string;
  elements: El[];
  room?: string;
  layout?: string;
}

/** 서버에 저장하는 본문 */
export interface ShowcaseContent {
  version: 2;
  pages: Page[];
  templateId?: string;
  themeKey?: string | null;
}

/** 인디포토 사진 (GET /showcase/photos) */
export interface ShowcasePhoto {
  photoId: number;
  externalId: string | null;
  thumbUrl: string | null;
  url: string | null;
  spaceTag: string | null;
  spaceName: string | null;
  /** USER · AI(인디포토 판정) · GUESS(시공사례 추정, 미확인) · CONFIRMED · NONE */
  spaceSource: 'USER' | 'AI' | 'GUESS' | 'CONFIRMED' | 'NONE';
  confidence: number | null;
  takenAt: string | null;
}

export interface ShowcaseSite {
  siteId: number;
  siteName: string;
  address: string;
  photos: ShowcasePhoto[];
}

export interface ImageRef {
  photoId?: number | null;
  externalId?: string | null;
  aiImgId?: number | null;
}

let seq = 1;
export function newId(): string {
  return 'el' + seq++;
}
/** 저장된 요소 번호(el123)와 새로 만들 번호가 겹치지 않게 */
export function syncIdSeq(pages: Page[]) {
  let max = 0;
  pages.forEach((p) =>
    p.elements.forEach((e) => {
      const m = /^el(\d+)$/.exec(e.id || '');
      if (m) max = Math.max(max, +m[1]);
    }),
  );
  seq = Math.max(seq, max + 1);
}
export function pageId(): string {
  return 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
}
